export default __webpack_public_path__ + "static/media/popAd6.72679d95.gif";